import React, { Component } from 'react'
import Date from '../Date'
import DataList from '../DataList'
import { aggregateEntries, summarizeSymptoms } from '../../utils'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
  snapshot: {
    borderBottom: `1px solid ${theme.borderColor}`,
    display: 'flex',
    height: 90,
    alignItems: 'center',
    padding: '10px 0',
  },
  activeSnapshot: {
    borderBottom: `1px solid ${theme.borderColor}`,
    display: 'flex',
    height: 90,
    alignItems: 'center',
    padding: '10px 0',
    backgroundColor: 'rgb(248, 248, 248)'
  },
  noEntry: {
    fontStyle: 'italic',
    width: 100,
    margin: 8,
    textAlign: 'center'
  }
})

const MAX_DISPLAY = 2

class Snapshot extends Component {
  render () {
    const { classes, snapshot, active, onClick } = this.props
    const entries = summarizeSymptoms(aggregateEntries(snapshot))
    return (
      <div className={active ? classes.activeSnapshot : classes.snapshot} onClick={e => onClick && onClick()} >
        <Date date={snapshot.date} />
        {
          entries.length > 0
            ? <DataList size={45} width={100} styles={{flexWrap: 'nowrap', justifyContent: 'space-evenly'}} truncated={entries.length > MAX_DISPLAY} data={entries.slice(0, MAX_DISPLAY).map(entry => {
              return { type: entry.type, superType: entry.superType }})
            } />
            : <div className={classes.noEntry}>No entry</div>
        }
      </div>
    )
  }
}

export default withStyles(styles)(Snapshot)



// WEBPACK FOOTER //
// ./src/components/SnapshotList/Snapshot.js